import React from 'react';
import { flowRight } from 'lodash/fp';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { animateScrollTop } from 'utils/scroll';

import { withAppContext } from './AppContext';

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        marginTop: theme.spacing(8),
        overflow: 'auto',
        marginLeft: '240px',
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor: theme.palette.background.default,
    },
    rootWithNotification: {
        marginTop: theme.spacing(16),
    },
    wide: {
        marginLeft: 0,
    },
    white: {
        background: '#fff',
    },
    body: {
        flex: '1 1 auto',
    },
    footer: {
        textAlign: 'center',
        padding: '4px 0',
        fontSize: '10pt',
        '& a': {
            margin: '0 0 0 8px',
            textDecoration: 'none',
            color: theme.palette.text.secondary,
        },
    },
});

class AppMain extends React.Component {
    state = {
        white: false,
    };

    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
        this.subscrptions = [];
    }
    componentDidMount() {
        const { app } = this.props;
        this.subscrptions = [
            app.on.background(white => {
                this.setState({ white });
            }),
            app.on.scroll(dir => {
                const y = dir === 'bottom' ? Number.MAX_SAFE_INTEGER : 0;
                animateScrollTop(this.scrollRef.current, y);
            }),
        ];
    }
    componentWillUnmount() {
        this.subscrptions.forEach(subscrption => subscrption());
        this.subscrptions = [];
    }
    render() {
        const {
            app,
            wide,
            white,
            children,
            classes,
            hasNotificationBar = false,
        } = this.props;
        const className = classNames({
            [classes.root]: true,
            [classes.rootWithNotification]: hasNotificationBar,
            [classes.wide]: wide,
            [classes.white]: white,
        });
        return (
            <div className={className} ref={this.scrollRef}>
                <div className={classes.body}>{children}</div>
                <Footer app={app} classes={classes} />
            </div>
        );
    }
}

function getLinks({ settings }) {
    if (settings) {
        const { brand } = settings;
        return [
            {
                label: 'Privacy',
                url: brand.privacy_policy_url,
            },
            {
                label: 'Terms',
                url: brand.partner_portal_terms_url,
            },
        ];
    }
    return [];
}
const currentYear = new Date().getFullYear();

const Footer = ({ app, classes }) => (
    <Typography
        component="div"
        color="textSecondary"
        className={classes.footer}
    >
        <span>&copy; {currentYear} CyberFOX LLC. All rights reserved.</span>
        {getLinks(app).map(({ label, url }) => (
            <a
                className={classes.footerLink}
                href={url}
                key={url}
                target="_blank"
                rel="noopener noreferrer"
            >
                {label}
            </a>
        ))}
    </Typography>
);

export default flowRight(withStyles(styles), withAppContext)(AppMain);
